import React from "react";
import {Card, AnchorButton, Classes as BP} from "@blueprintjs/core";
import styles from "../auth/styles/Login.module.scss";

class QuickBooksDisconnected extends React.Component {
  render() {
    return (
      <div className={styles.login}>
        <Card className={styles.card}>
          <div className={styles.wrapper}>
            <div className={styles.signin}>
              <h3 className={BP.HEADING}>QuickBooks Disconnected</h3>
              <AnchorButton
                className="m-t-md"
                fill
                href="/"
                icon="log-in"
                intent="primary"
                large
              >
                Return Home
              </AnchorButton>
              <p className={`${BP.TEXT_MUTED} ${BP.RUNNING_TEXT} m-t-md m-b-0`}>
                Flightpath has been successfully disconnected from your QuickBooks. If you have any further questions, please contact <a href="mailto:support@flightpathfinance.com">support@flightpathfinance.com</a>.
              </p>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

export default QuickBooksDisconnected;
